<template>
	<b-container fluid class="margin-top-header">
		<b-row>
			<b-col deck>
				<b-row v-if="showConfirmData">
					<b-col cols="12">
						<b-link class="text-macal" to="/autos/vende/cotizar">
							<b><font-awesome-icon :icon="['fal', 'chevron-left']" />VOLVER</b>
						</b-link>
					</b-col>
					<b-col cols="12" md="8" offset-md="2">
						<b-row>
							<b-col>
								<h1 class="text-center mt-2">¡Estás a un Click!</h1>
						<h5 class="text-center">Hola {{phone_reservation.name}}, confirma el resumen de tu agenda</h5>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="mt-2">
								Tu auto:
						<div class="bg-grey p-2"><b> {{data.brandText}} {{data.modelText}} {{data.versionText}}, {{data.yearText}}, {{data.kmText}} KM</b></div>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="12" md="6" class="mt-2">
								Cuando:
								<div class="bg-grey p-2"><b> {{reservation.date | moment("dddd D, MMMM")}}</b></div>
							</b-col>
							<b-col cols="12" md="6" class="mt-2">
								Donde:
								<div class="bg-grey p-2"><b> {{branch_id.Valor}}</b></div>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="12" md="6" class="mt-2">
								Hora:
								<div class="bg-grey p-2"><b> {{[reservation.hour, "HH:mm:ss"] | moment("HH:mm")}}</b></div>
							</b-col>
							<b-col cols="12" md="6" class="mt-2">
								Oferta:
								<div class="bg-grey p-2"><b> $ {{car.offer}}</b></div>
								<small>Oferta sujeta a modificaciones según inspección previa.</small>
							</b-col>
						</b-row>
						<b-col v-if="calendar_reservation_loading" cols="12" class="text-center mt-5">
							<grid-loader :color="color"></grid-loader>
						</b-col>
						<b-row class="mt-4">
							<b-col class="text-center">
							<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="sendReservation" :disabled="calendar_reservation_loading">Confirmar</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<b-row v-else>
					<b-col cols="12">
						<b-link class="text-macal" to="/autos/vende/cotizar">
							<b><font-awesome-icon :icon="['fal', 'chevron-left']" />VOLVER</b>
						</b-link>
					</b-col>
					<b-col cols="12" md="8" offset-md="2">
						<h1 class="text-center mt-2">Completa tus datos</h1>
						<b-form-group label="Nombre">
							<b-form-input v-model.trim="$v.phone_reservation.name.$model" :state="$v.phone_reservation.name.$dirty ? !$v.phone_reservation.name.$error : null" ></b-form-input>
							<b-form-invalid-feedback id="input-1-live-feedback">
								Debes ingresar nombre.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-form-group label="Apellido">
							<b-form-input v-model.trim="$v.phone_reservation.lastname.$model" :state="$v.phone_reservation.lastname.$dirty ? !$v.phone_reservation.lastname.$error : null" ></b-form-input>
							<b-form-invalid-feedback id="input-1-live-feedback">
								Debes ingresar apellido.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-form-group label="Teléfono">
							<b-form-input v-model.trim="$v.reservation.phone.$model" :state="$v.reservation.phone.$dirty ? !$v.reservation.phone.$error : null"></b-form-input>
							<b-form-invalid-feedback id="input-1-live-feedback">
								Debes ingresar teléfono.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-form-group label="Email">
							<b-form-input v-model.trim="$v.reservation.email.$model" :state="$v.reservation.email.$dirty ? !$v.reservation.email.$error : null"></b-form-input>
							<b-form-invalid-feedback id="input-1-live-feedback">
								Correo Inválido.
							</b-form-invalid-feedback>
						</b-form-group>
						<b-col cols="12" v-if="reservation.hour" class="text-right">
							<b-button size="lg" class=" mt-2 px-5" variant="outline-macal" @click="validateConfirmData()">Continuar</b-button>
						</b-col>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import {es} from 'vuejs-datepicker/dist/locale';
	import { required, minLength, maxLength, email } from "vuelidate/lib/validators";

export default {
	name: 'v-sell-modal',
	components: {
	},
	props: {
		price: String,
		data: {default: null},
		car: {default: null},
		reservation: {default: null},
		branch_id: {default: null},
	},
	data (){
		return{
			send_loading: false,
			calendar_get_dates_loading: false,
			phone_reservation_loading: false,
			calendar_reservation_loading: false,
			calendar_get_hours_loading: false,
			showUserData: false,
			showConfirmData: false,
			showSuccess: false,
			showCallQuote: false,
			es: es,
			calendarData: {},
			setSchedule: false,
			captcha: {
				sitekey: process.env.VUE_APP_CAPTCHA_KEY,
				valid: false,
				error: false,
			},
            color: "#E4610C",
			plateData: {
				brand: null,
				year: null,
				model: null
			},
			loading: {
				brand: false,
				year: false,
				model: false,
				version: false,
			},
			errors: '',
			hour: "",
			date: "",
			brands: [],
			years: [],
			models: [],
			versions: [],
			kms: [
				{ value: 5000, text: "5.000" },
				{ value: 10000, text: "10.000" },
				{ value: 20000, text: "20.000" },
				{ value: 30000, text: "30.000" },
				{ value: 40000, text: "40.000" },
				{ value: 50000, text: "50.000" },
				{ value: 60000, text: "60.000" },
				{ value: 70000, text: "70.000" },
				{ value: 80000, text: "80.000" },
				{ value: 90000, text: "90.000" },
				{ value: 100000, text: "100.000" },
				{ value: 150000, text: "150.000" },
				{ value: 200000, text: "200.000" },
			],
			dateState: {
				disabled: {
					to: new Date,
					from: new Date,
				},
				highlighted: {}
			},
			dateTitle: null,
			hourTitle: null,
			hours: [],
			phone_reservation:{
				name: "",
				lastname: ""
			},
			submited: false,
		}
	},
	validations: {
		car:{
			brand: { required },
			year: { required },
			model: { required },
			version: { required },
			km: { required },
			terms: { required },
		},
		reservation: {
			phone: {required, minLength: minLength(12), maxLength: maxLength(12)},
			email: {required, email},
		},
		phone_reservation: {
			name: {required, minLength: minLength(3)},
			lastname: {required, minLength: minLength(3)},
		}
	},
	computed: {},
	mounted() {
		this.$moment.locale('es');
		this.amount= this.price;
	},
	beforeMount() {
		this.hasReservation();
	},
	methods: {
		hasReservation(){
			if(this.reservation == null){
				this.$router.push({ name: 'vehicles-sell-quote' });
			}
		},
		addPlusToPhone(){
			if(this.reservation.phone !== null){
				this.reservation.phone = '+'+this.reservation.phone.replace(/[|&;$%@"<>()+a-zA-Z,]/g,"");
			}
		},
		validateConfirmData(){
			this.$v.phone_reservation.$touch()
			this.$v.reservation.$touch()
			if(!this.$v.phone_reservation.$invalid && !this.$v.reservation.$invalid) this.showConfirmData = true
		},
		onVerify: function (response) {
			if(response.length > 0){
				this.captcha.valid = true
				this.captcha.error = false
				this.reservation["g-recaptcha-response"] = response
			}
		},
		uppercase(){
			this.car.plate = this.car.plate.toUpperCase()
		},
		sendReservation(){
			const cur = this;
			this.calendar_reservation_loading = true
			if(!this.$v.phone_reservation.$invalid && !this.$v.reservation.$invalid){
				this.reservation.name = this.phone_reservation.name
				this.reservation.lastname = this.phone_reservation.lastname
				this.axios.post("sells/reservation", this.reservation).then(() => {
					cur.showSuccess = true;
					this.calendar_reservation_loading = false;
					cur.$router.push({ name: 'vehicles-sell-quote-schedule-success', params: {reservation: cur.reservation, data: cur.data, car: cur.car, branch_id: cur.branch_id}});
				})
				.catch(() => {
					this.calendar_reservation_loading = true
				})
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	#modal-sell___BV_modal_outer_{
		z-index: 1060 !important;
	}
	#modal-sell .multiselect-sm {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
	}
	#modal-sell .multiselect-sm .multiselect__tags {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
		padding: 0.25rem 0.5rem !important;
	}
	#modal-sell .multiselect-sm .multiselect__select {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		padding: 0.25rem 0.5rem !important;
	}
	.w-100 .vdp-datepicker__calendar{
		width: 100%;
	}
	.captcha-element>div>div{
		margin-left: auto;
		margin-right: auto;
	}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
